import { render, staticRenderFns } from "./svg-demo.vue?vue&type=template&id=2dbe86f8&scoped=true"
import script from "./svg-demo.vue?vue&type=script&lang=js"
export * from "./svg-demo.vue?vue&type=script&lang=js"
import style0 from "./svg-demo.vue?vue&type=style&index=0&id=2dbe86f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe86f8",
  null
  
)

export default component.exports